@if (get(subcategoryLinksV2Row, 'subcategory_links_v2.subcategory_links_v2')) {
  <section class="subcategory-links-v2 p-0">
    @for (row of get(subcategoryLinksV2Row, 'subcategory_links_v2.subcategory_links_v2', []); track row) {
      <div>
        <div [class.gray-bg]="get(row, 'gray_background')">
          <div class="container padding-container">
            <h2 class="row-header">
              {{ row.header }}
            </h2>
            <div class="subcategory-grid" [style.--grid-columns]="get(row, 'layout')">
              @for (subcategory of get(row, 'subcategory_links', []); track subcategory) {
                <div>
                  <div class="subcategory-link-container fx-col">
                    @if (get(subcategory, 'main_image.href', '')) {
                      <a
                        class="subcategory-card-container fx-col fx-wrap"
                        [style.--gradient-color-1]="subcategory.background_theme.colors[0]"
                        [style.--gradient-color-2]="subcategory.background_theme.colors[1]"
                        [style.--gradient-color-3]="subcategory.background_theme.colors[2]"
                        [href]="subcategory?.link?.routerLink"
                        [attr.aria-label]="subcategory?.link?.title"
                        >
                        <img [src]="getWebpImg(get(subcategory, 'main_image.href'))" alt="" />
                        @if (get(subcategory, 'logo.href', '')) {
                          <img
                            class="card-logo"
                            [src]="getWebpImg(get(subcategory, 'logo.href', ''))"
                            alt=""
                            />
                        }
                      </a>
                    }
                    @if (get(subcategory, 'link.routerLink', '')) {
                      <!-- The image card is the tab stop when it exists; otherwise this link is -->
                      <a
                        [attr.tabindex]="get(subcategory, 'main_image.href', '') ? -1 : null"
                        [href]="subcategory?.link?.routerLink"
                        class="subcategory-link-text d-flex flex-row align-items-center"
                        >
                        <span>
                          {{ subcategory.link.title }}
                        </span>
                        <mat-icon>chevron_right</mat-icon>
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </section>
}
